import MastPageController from "./mastPageController";
import TranslationService from "ceres/app/services/TranslationService";

var mastCtrl = new MastPageController();

$.fn.scrollEnd = function(callback, timeout)
{
    $(this).scroll(function()
    {
        var $this = $(this);

        if ($this.data("scrollTimeout"))
        {
            clearTimeout($this.data("scrollTimeout"));
        }
        $this.data("scrollTimeout", setTimeout(callback, timeout));
    });
};

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

$("document").ready(function()
{

    if(getCookie("HoferItemsPerPage")){
        App.config.pagination.itemsPerPage = getCookie("HoferItemsPerPage")
    }
    if(getCookie("HoferSorting")){
        App.config.sorting.defaultSortingSearch = getCookie("HoferSorting")
        App.config.sorting.defaultSorting = getCookie("HoferSorting")
    }

    var $body = $("body");

    $body.addClass("docReady");

    mastCtrl.init();

    if ($("html").hasClass("ie"))
    {
        $(window).scrollEnd(function()
        {
            mastCtrl.scroll();
        }, 100);
    }
    else
    {
        $(window).scrollEnd(function()
        {
            mastCtrl.scroll();
        }, 50);
    }

    $(window).resize(function()
    {
        // console.log('resize');
        mastCtrl.resize();
    });

    $(window).bind(function()
    {
        mastCtrl.touchend();
    });

    // $("#searchBox").find("input.search-input").attr("placeholder", "Ich suche nach ...");
    if ($(".selected-filters.clearfix").children().length > 0)
    {
        $(".look_machartFilterToggle").addClass("look_filterIsActive");
    }

    if($("#hint-en").length){
        $("#hint-en").prependTo(".tab-pane.isInUsage");
    }

    if($('.content-of-ringsize').length){

        const unicodeMapping = {
            'u00BD' : '½',//'&#189;',
            'u2153' : '⅓',//'&#8531;',
            'u2154' : '⅔',//'&‌#8532;',
            'u00bc' : '¼',//'&‌#188;',
            'u00BE' : '¾',//'&‌#190;',
            'u2155' : '⅕',//'&‌#8533;',
            'u2156' : '⅖',//'&‌#8534;',
            'u2157' : '⅗',//'&‌#8535;',
            'u2158' : '⅘',//'&‌#8536;',
            'u2159' : '⅙',//'&‌#8537;',
            'u215A' : '⅚',//'&‌#8538;',
            'u2150' : '⅐',//'&‌#8528;',
            'u215B' : '⅛',//'&‌#8539;',
            'u215C' : '⅜',//'&‌#8540;',
            'u215D' : '⅝',//'&‌#8541;',
            'u215E' : '⅞',//'&‌#8542;',
            'u2151' : '⅑',//'&‌#8529;',
            'u2152' : '⅒',//'&‌#8530;',
            'u2189' : '↉',//'&‌#8585;',
        };

        let table = $('.ringgroesse-row')[0].dataset.table;
        let value = $('.ringgroesse-row')[0].dataset.value;

        table = table.split("###");
        let newTable = [];

        for(let key in table){
            let newArr = table[key].split("=");
            newArr[0] = newArr[0].replace(/\\/, "");
            newArr[0] = newArr[0].replace('n', '');
            newArr[0] = newArr[0].replace('r', '');
            newArr[0] = newArr[0].replace('""', '"');
            newArr[1] = newArr[1].replace('""', '"');
            newTable.push(newArr);
        }

        let retString = "";

        for(let key in newTable){
            if(newTable[key][0] == value+""){
                retString = newTable[key][1].replace(/"/g, '');
                break;
            }
        }

        if(retString == ""){
            retString = value;
        }else{
            let lang = $("html").attr("lang");
            let insertedText = TranslationService.translate("HoferAntikschmuck::Template.ringFormatText");

            // wenn 50=50 ~ UK K, US 5¼
            //retString = retString.replace("~", insertedText);

            // wenn 50=5¼
            retString = value + ' ' + insertedText + ' ' +retString;

            for(let key in unicodeMapping){
                retString = retString.replaceAll("\\"+key, unicodeMapping[key]);
                retString = retString.replaceAll("\\"+key.toLowerCase(), unicodeMapping[key]);
            }
        }

        $('.content-of-ringsize').html(retString);

        if($('.content-of-ringsize').html() != "" && $('.content-of-ring-changeable').length){
            if($('.content-of-ring-changeable').html().indexOf("<br>") > -1){
                $('.content-of-ringsize').html($('.content-of-ringsize').html() + $('.content-of-ring-changeable').html());
            }else{
                $('.content-of-ringsize').html($('.content-of-ringsize').html() + "<br>" + $('.content-of-ring-changeable').html().trim());
            }
            $('.content-of-ring-changeable').closest("tr").remove();
        }

        $('.content-of-ringsize').html($('.content-of-ringsize').html().trim());

    }

    $("[data-currenttemplate=\"tpl.cancellation-rights\"] h1, [data-currenttemplate=\"tpl.legal-disclosure\"] h1, [data-currenttemplate=\"tpl.privacy-policy\"] h1, [data-currenttemplate=\"tpl.terms-conditions\"] h1").addClass("mt-5");

    $(".filter-sidebar__close").click(function(){
        $("body").removeClass("filter-open");
    });

    $('.filter-sidebar__overlay').click(() => {
        $('body').removeClass('filter-open');
    });


    document.addEventListener('contactFormSent', e => {
        $('#item-question').modal("hide")
    })

});

$(document).ajaxComplete(function(event, xhr, settings)
{
    var url = settings.url;

    if (url.indexOf("/rest/io/facet") >= 0)
    {
        var $itemFilter = $(".modify_autoUpdateFilter");
        var ceresStore = window.ceresStore;

        if ($itemFilter.length > 0)
        {
            ceresStore.dispatch("loadItemList");
        }
    }
});

$(document).ready(function()
{

    // SK: https://machart.myjoli.de/todos/details/id/5513

    var userAgent = navigator.userAgent.toLowerCase();
    var isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);

    if (isTablet === true)
    {
        var $firstClickObject = null;
        var link = null;

        $(".look_mainNav .look_mainNavigationList > li > a").click(function(evt)
        {
            if (link === this.href)
            {
                window.location = this.href;
            }
            else
            {
                evt.preventDefault();
            }
            link = this.href;

        });
    }

    if ($("body").hasClass("page-type-home"))
    {

        var selectElementsToSlide = "";

        if (window.innerWidth > 1150)
        {

            selectElementsToSlide = -30;

        }
        else if (window.innerWidth > 992)
        {

            selectElementsToSlide = -33;

        }
        else if (window.innerWidth > 767)
        {

            selectElementsToSlide = -36;

        }
        else if (window.innerWidth > 575)
        {

            selectElementsToSlide = -39;

        }
        else if (window.innerWidth < 575)
        {

            selectElementsToSlide = -30;

        }

        // Nicht mehr gebraucht vorerst - stashed
        // var productList = $('.product-list > li');
        // const countProductListElements = productList.length;

        fireSlice(selectElementsToSlide);

        var clicks = 0;
        var startToSlice = 0;
        var endOfSlice = 0;

    }

    $(".home_seemore").find("a").click(function(e)
    {

        var tempTimeOne = 1000;
        var tempTimeTwo = 3000;
        var tempTimeThree = 4000;

        if (window.innerWidth > 1150)
        {

            if (clicks === 0)
            {

                e.preventDefault();

                startToSlice = 15;
                endOfSlice = 20;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 20;
                endOfSlice = 25;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 25;
                endOfSlice = 30;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 1)
            {

                e.preventDefault();

                startToSlice = 30;
                endOfSlice = 35;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 35;
                endOfSlice = 40;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 40;
                endOfSlice = 45;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 2)
            {

                window.location.href = "https://www.hofer-antikschmuck.de/schmuckstuecke";

            }

        }
        else if (window.innerWidth > 992)
        {

            if (clicks === 0)
            {

                e.preventDefault();

                startToSlice = 12;
                endOfSlice = 16;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 16;
                endOfSlice = 20;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 20;
                endOfSlice = 24;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 1)
            {

                e.preventDefault();

                startToSlice = 24;
                endOfSlice = 28;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 28;
                endOfSlice = 32;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 32;
                endOfSlice = 36;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 2)
            {

                window.location.href = "https://www.hofer-antikschmuck.de/schmuckstuecke";

            }

        }
        else if (window.innerWidth > 767)
        {

            if (clicks === 0)
            {

                e.preventDefault();

                startToSlice = 15;
                endOfSlice = 18;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 18;
                endOfSlice = 21;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 21;
                endOfSlice = 24;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 1)
            {

                e.preventDefault();

                startToSlice = 24;
                endOfSlice = 27;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 27;
                endOfSlice = 30;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 30;
                endOfSlice = 33;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 2)
            {

                window.location.href = "https://www.hofer-antikschmuck.de/schmuckstuecke";

            }

        }
        else if (window.innerWidth > 575)
        {

            if (clicks === 0)
            {

                e.preventDefault();

                startToSlice = 14;
                endOfSlice = 16;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 16;
                endOfSlice = 18;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 18;
                endOfSlice = 20;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 1)
            {

                e.preventDefault();

                startToSlice = 20;
                endOfSlice = 22;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 22;
                endOfSlice = 24;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 24;
                endOfSlice = 26;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 2)
            {

                window.location.href = "https://www.hofer-antikschmuck.de/schmuckstuecke";

            }

        }
        else if (window.innerWidth < 575)
        {

            if (clicks === 0)
            {

                e.preventDefault();

                startToSlice = 15;
                endOfSlice = 16;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 16;
                endOfSlice = 17;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 17;
                endOfSlice = 18;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 1)
            {

                e.preventDefault();

                startToSlice = 18;
                endOfSlice = 19;
                handleSlices(tempTimeOne, startToSlice, endOfSlice);

                startToSlice = 19;
                endOfSlice = 20;
                handleSlices(tempTimeTwo, startToSlice, endOfSlice);

                startToSlice = 20;
                endOfSlice = 21;
                handleSlices(tempTimeThree, startToSlice, endOfSlice);

            }
            else if (clicks === 2)
            {

                window.location.href = "https://www.hofer-antikschmuck.de/schmuckstuecke";

            }

        }

        ++clicks;

    });

        $(document).on('click', 'a[class="faq__question"]', function (event) {
            event.preventDefault();

        $('html, body').animate({
            scrollTop:  window.innerWidth > 767 ? $($.attr(this, 'href')).offset().top - 53 : $($.attr(this, 'href')).offset().top
        }, 500);
        });
});

function handleSlices(tempTime, startToSlice, endOfSlice)
{

    setTimeout(function()
    {
        fireSlice(startToSlice, endOfSlice);
    }, tempTime);

}

function fireSlice(startToSlice, endOfSlice)
{

    var sliceDesktopElements = $(".product-list > li").slice(startToSlice, endOfSlice);

    sliceDesktopElements.each(function(index, element)
    {

        $(element).fadeIn(1500).toggleClass("look_hidden");

    });
    $(window).scrollTop($(window).scrollTop() + 1);
}
